import { render } from "./SubMenu.vue?vue&type=template&id=447a4b24&scoped=true&ts=true"
import script from "./SubMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubMenu.vue?vue&type=script&setup=true&lang=ts"

import "./SubMenu.vue?vue&type=style&index=0&id=447a4b24&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447a4b24"],['__file',"src/components/scan/parts/SubMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "447a4b24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('447a4b24', __exports__)) {
    console.log('reload')
    api.reload('447a4b24', __exports__)
  }
  
  module.hot.accept("./SubMenu.vue?vue&type=template&id=447a4b24&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('447a4b24', render)
  })

}


export default __exports__